import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import useVariants from "./useVariants";
import EmptyData from "../../../../Global/EmptyData";
import { ImageCard } from "../../../../Global/ImageCard";
import OrderColumn from "../../../../Global/OrderColumn";

const Variants = ({ customerKey }) => {
  const {
    isLoading,
    imageData,
    isFetching,
    showEditModal,
    showImageModal,
    paginationOptions,
    productVariantList,
    productVariantState,
    handleEditColumnsClick,
    updateVariantFields,
    handlePagination,
    handleClearClick,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useVariants(customerKey);
  return (
    <>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={productVariantState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: productVariantState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {productVariantList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={productVariantList?.data?.result || []}
            uniqueID={"id"}
            fields={productVariantList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={productVariantState?.clearSelection}
            perpage={productVariantState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {productVariantList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={productVariantState?.currentPage}
            totalPageCount={Math.ceil(
              productVariantList?.data?.result?.length /
                productVariantState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === productVariantState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={productVariantList?.data?.fields || []}
              moduleId={productVariantList?.data?.module_id}
              updateData={updateVariantFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </>
  );
};

export default Variants;
